import { render, staticRenderFns } from "./HighschoolAutoCompleteCartoonAnimation.vue?vue&type=template&id=37a7aa74"
import script from "./HighschoolAutoCompleteCartoonAnimation.vue?vue&type=script&lang=js"
export * from "./HighschoolAutoCompleteCartoonAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports